import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type AppPage = 'dashboard' | 'meal-builder' | 'shopping-list' | 'settings'

interface AppStore {
  view: 'sign-in' | 'sign-up'
  setView: (view: 'sign-in' | 'sign-up') => void

  hasCompletedOnboarding: boolean
  setHasCompletedOnboarding: (v: boolean) => void

  page: AppPage
  setPage: (page: AppPage) => void

  activePlanId: string | null
  setActivePlanId: (id: string | null) => void

  chatOpen: boolean
  setChatOpen: (open: boolean) => void

  mapsEnabled: boolean
  setMapsEnabled: (v: boolean) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      view: 'sign-in',
      setView: (view) => set({ view }),

      hasCompletedOnboarding: false,
      setHasCompletedOnboarding: (v) => set({ hasCompletedOnboarding: v }),

      page: 'dashboard',
      setPage: (page) => set({ page }),

      activePlanId: null,
      setActivePlanId: (id) => set({ activePlanId: id }),

      chatOpen: false,
      setChatOpen: (open) => set({ chatOpen: open }),

      mapsEnabled: true,
      setMapsEnabled: (v) => set({ mapsEnabled: v }),
    }),
    {
      name: 'mealmap-preferences',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ mapsEnabled: state.mapsEnabled }),
    }
  )
)
